/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

module.exports = reEscape;



//////////////////
// WEBPACK FOOTER
// ../node_modules/lodash/_reEscape.js
// module id = 822
// module chunks = 20 21 22 23 24 25 26 27 28 29 30